/* eslint-disable @nx/enforce-module-boundaries */
import { Tab } from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
export const MyNetworkManageTabs = forwardRef(({ ...props }, ref) => {
  const { pendingInvitations, tabs, requestsSent, setActiveTab, activeTab } =
    useContext(MyNetworkContext);

  
  return (
    <>
      {tabs?.map?.((t, tIndex) => (
        <Tab
          onClick={(e) => setActiveTab(t.name)}
          display={t?.show ? '' : 'none'}
          key={tIndex}
          fontSize={["sm", "md"]}
        >
          {t?.title}
        </Tab>
      ))}
    </>
  );
});
